import WindowUtils from '@/utils/window-utils';
import { storageService, cacheService, Logger } from '@ol/ol-ui-core';
import store from '@/store';


class ClearLocalStorageRedirectToLogoutService {
  public async isClearStorageAndRedirectToLogoutPage():Promise<boolean> {
    const hash = window.location.hash;
    return hash.startsWith('#/clearLocalStorageRedirectToLogoutPage?redirectToLogoutUrl=');
  }


  public async clearLocalStorageAndLogout():Promise<void> {
    localStorage.setItem('isDoingSingleSignOut', `${true}`);
    await store.dispatch('mainModule/clearAll');
    await cacheService.clearAll();
    await storageService.cleanStorageAfterLogout();
    const redirectToLogoutUrl = '?redirectToLogoutUrl=';
    const hash = window.location.hash;
    const index = hash.indexOf(redirectToLogoutUrl);
    let url = hash.substring(index + redirectToLogoutUrl.length);
    Logger.info(`clearLocalStorageRedirectTo....${url}`);
    if (url) {
      url += '&afterCleanLocalStorage=true';
      WindowUtils.setLocationHref(url);
    }
  }
}

export const clearLocalStorageRedirectToLogoutService = new ClearLocalStorageRedirectToLogoutService();
